import * as React from "react";
import { ContextValue } from "./types";

const Context = React.createContext((null as unknown) as ContextValue);

export default Context;
